import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { firstLoginUpdate } from '@/store/users/actions';

import { Button, ConfigProvider, Modal } from 'antd';

import vector1 from './icon/vector1.png';
import vector2 from './icon/vector2.png';

import PropTypes from 'prop-types';

import css from './WelcomeModal.module.scss';

import welcomeModalImg from '@/assets/images/welcomeModalImg.png';

const WelcomeModal = ({ open, onClose }) => {
  const { t } = useTranslation('modalWelcome');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const contentBlock = [t('help1'), t('help2'), t('help3'), t('help4'), t('help5'), t('help6')];

  const handleHideClick = () => {
    dispatch(
      firstLoginUpdate(() => {
        navigate('/track/18647');
        onClose();
      })
    );
  };

  const handleCancel = () => {
    dispatch(
      firstLoginUpdate(() => {
        onClose();
      })
    );
  };

  const footerWelcomeModal = () => (
    <div className={css['WelcomeModal-footer']}>
      <Button size='large' type='primary' onClick={handleHideClick}>
        {t('toStudyBtn')}
      </Button>
    </div>
  );

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: '#F8F4EF',
            headerBg: '#F8F4EF',
            titleColor: '#F8F4EF',
            footerBg: '#F8F4EF',
          },
        },
      }}
    >
      <Modal
        className={css['WelcomeModal']}
        open={open}
        width={800}
        zIndex={1005}
        footer={footerWelcomeModal}
        onCancel={handleCancel}
      >
        <div className={css['WelcomeModal-container']}>
          <img className={css['WelcomeModal-img-title']} src={welcomeModalImg} />

          <div className={css['WelcomeModal-title']}>{t('titleWelconeModal')}</div>
          <div className={css['WelcomeModal-subTitle']}>{t('subTitleWelconeModal')}</div>

          <div className={css['WelcomeModal-content']}>
            {contentBlock?.map((item, index) => (
              <div key={`welcome-${index}`} className={css['WelcomeModal-content-block']}>
                {item}
              </div>
            ))}
            <img className={css['WelcomeModal-img-vector1']} src={vector1} />
            <img className={css['WelcomeModal-img-vector2']} src={vector2} />
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

WelcomeModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default WelcomeModal;
